import React from "react";

const shweta_jadhav = () => {
  return (
    <div>
      <h1>Shweta Jadhav</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        To appear for the aptitude test, the CGPA requirement was 7.5. Students
        were shortlisted for interviews based on their aptitude test score.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The interview process began with an aptitude test conducted at the
        college on 5th September. After the test, shortlisted candidates
        progressed to the interview stage, which took place on 15th September.
        The interviews were divided into three rounds:
        <br />
        - First Round: Technical 1<br />
        - Second Round: Technical 2<br />- Third Round: HR/Behavioral Interview{" "}
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The test was conducted on the AMCAT platform and consisted of:
        <br />
        - Critical Section ( Matrix DFS question. Hard )<br />
        - Verbal Ability &amp; Comprehension Section
        <br />
        - Graphical &amp; Statistical Interpretation
        <br />
        - 2 Coding Questions (2 easy)
        <br />
        All questions were compulsory with no negative marking.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        25
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The results of the aptitude test were announced on 11th September, and
        the interviews were scheduled for the 15th. During this gap, I revised
        my projects and went through short notes on the technologies mentioned
        in my resume. I also prepared and customized my answers for commonly
        asked HR questions. Additionally, I reviewed the solution to the tricky
        question from the aptitude test, although it was not asked in the
        interview.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        The interview process consisted of three rounds - two technical and one
        HR.
        <br />
        <strong>1st Technical Round:</strong> This round was conducted online at
        college and lasted for about 45 to 50 minutes. It was mostly based on my
        resume. The interviewer started with questions from DBMS, mainly
        focusing on indexing and B+ trees. Then he gave me a problem-solving
        question to design a parking lot system. I had to come up with a search
        algorithm to efficiently find and assign a parking lot to a car.{" "}
        <a href="https://leetcode.com/problems/design-parking-system/description/">
          Design a Parking Lot
        </a>
        . He also asked me about multi-threading, parallel computing and some
        real-life analytical questions.
        <br />
        <strong>2nd Technical Round:</strong> In this round, the interviewer
        mostly focused on my projects. He asked me to explain my favorite
        project in detail, and after my explanation, he asked several
        cross-questions about the data structures and approaches used. Then he
        gave me a real-life problem to design logic for two elevators. He then
        asked deeper follow-up questions like how I would make the code
        scalable, and how I would balance load if one lift had more requests
        than the other. Finally, he asked a few short programming questions such
        as writing code to check for a palindrome and explaining sorting logic.
        This round was about an hour long.
        <br />
        <strong>HR Round:</strong> The HR round was quite relaxed. The
        interviewer asked general questions such as what my strengths and
        weaknesses are, what was the lowest moment in my life, and how I
        overcame it. The round was more about understanding my personality and
        mindset than technical skills. This round lasted around 10 to 15
        minutes.
        <br />
        <strong>Finally 10 students were selected for internship.</strong>
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        My interview primarily focused on DSA and system design. The interviewer
        evaluated my understanding of the subjects, my thinking ability, and my
        problem-solving skills. Most of the questions were based on the topics
        mentioned in my resume.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        <strong>DSA:</strong> Striver’s SDE sheet &amp; their YouTube channel,
        Abdul Bari Udemy Course (also available on YouTube), Hackerrank /
        Leetcode
        <br />
        <strong>OS:</strong> Geeks For Geeks notes, Abhijeet sir videos/notes
        <br />
        <strong>DBMS:</strong> Love Babbar playlist, GFG Notes
        <br />
        <strong>Web Dev:</strong> Web Development Bootcamp Udemy, Code with
        Harry
        <br />
        <strong>For Aptitude:</strong>{" "}
        <a href="https://www.indiabix.com/">IndiaBix</a>
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice coding regularly. Focus on building a strong foundation in each
        data structure before moving on to more complex ones. Make sure you can
        comfortably solve medium-level problems on platforms like LeetCode or
        HackerRank for every topic you learn. Consistency and understanding the
        logic behind each problem are more important than just memorizing
        solutions.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I wasn’t asked any questions about clubs or extracurricular
        activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Prepare well for the aptitude test by studying topics such as data
        interpretation, candlestick graphs, and language skills from platforms
        like InterviewBit. Review the real-life applications of the data
        structures you have used in your projects or mentioned in your resume.
        Additionally, make sure to research the company thoroughly before the
        interview to understand its work, values, and recent developments.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Be confident, trust your skills, and keep learning.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email:</strong> jadhavsb23.comp@coeptech.ac.in
      </p>
    </div>
  );
};

export default shweta_jadhav;
